'use strict';

const ContourPreviewActions = function ContourPreviewActions (Flux, APP_DISPATCHER_ID) {

  const Actions = Flux.Actions.create('ContourPreviewActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'ShowContourPreview',
    purpose: 'Show site selector dialog',
    payload: []
  });

  Actions.add({
    name: 'ExportContour',
    purpose: 'Export a contour object for processing',
    payload: ['payload']
  });

  return Actions;
};

ContourPreviewActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = ContourPreviewActions;



// WEBPACK FOOTER //
// ./src/app/shared/contourPreview/ContourPreviewActions.js